module.exports = __webpack_public_path__ + "img/nature4.c1466bb4.jpg";